<template>
  <div class="questionEdit">
    <el-dialog
      class="questionEdit_dialog"
      :title="[null, undefined, ''].includes(form.vId) ? '新增题目' : '编辑题目'"
      :visible.sync="visible"
      width="620px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="close">
      <div class="content">
        <el-form ref="form" class="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item class="form_item" label="题目类型" prop="questionsType">
            <el-radio-group class="form_item_radio_group" v-model="form.questionsType" @input="questionsTypeChange">
              <el-radio class="form_item_radio" :label="0">单选题</el-radio>
              <el-radio class="form_item_radio" :label="1">多选题</el-radio>
              <el-radio class="form_item_radio" :label="4">简答题</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="form_item" label="是否必填" prop="required">
            <el-radio-group class="form_item_radio_group" v-model="form.required">
              <el-radio class="form_item_radio" :label="1">是</el-radio>
              <el-radio class="form_item_radio" :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="form_item" label="题目名称" prop="questionsTitle">
            <el-input v-model="form.questionsTitle" type="textarea" :autosize="{ minRows: 1, maxRows: 3}" resize="none" placeholder="请输入" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item class="form_item" label="题目描述" prop="questionDescribe">
            <el-input v-model="form.questionDescribe" type="textarea" :autosize="{ minRows: 1, maxRows: 3}" resize="none" placeholder="请输入(非必填)" maxlength="200"></el-input>
          </el-form-item>
          <el-form-item v-if="[0, 1].includes(form.questionsType)" class="form_item" label="题目选项" required>
            <div class="answer_list">
              <div v-for="answer in form.answers" :key="answer.vId" class="answer_item">
                <el-radio v-if="form.questionsType === 0" :class="{ answer_single_radio: true, error: [null, undefined, ''].includes(answer.answerContent) }" value="0" disabled>
                  <el-input class="answer_item_input" v-model.trim="answer.answerContent" placeholder="请输入选项" maxlength="100"></el-input>
                </el-radio>
                <el-checkbox v-if="form.questionsType === 1" :class="{ answer_multiple_checkbox: true, error: [null, undefined, ''].includes(answer.answerContent) }" value="0" disabled>
                  <el-input class="answer_item_input" v-model.trim="answer.answerContent" placeholder="请输入选项" maxlength="100"></el-input>
                </el-checkbox>
                <el-button class="answer_item_del" type="text" icon="el-icon-delete" @click="delAnswer(answer.vId)"></el-button>
              </div>
              <el-button class="answer_add" type="text" icon="el-icon-plus" @click="addAnswer">新增选项</el-button>
            </div>
          </el-form-item>
          <el-form-item v-if="[4].includes(form.questionsType)" class="form_item" label="示例图片">
            <div class="example">
              <div class="example_operate">
                <el-button class="example_operate_btn" type="primary" :loading="uploading" @click="uploadExampleImg">点击上传</el-button>
                <div class="example_operate_tips">限jpg/png文件，最多上传5张</div>
              </div>
              <div v-if="form.sampleImages.length > 0" class="example_list">
                <div v-for="(exampleImg, exampleImgIndex) in form.sampleImages" :key="exampleImgIndex" class="example_item">
                  <img class="example_item_img" :src="exampleImg">
                  <div class="example_item_del">
                    <span class="el-icon-delete example_item_del_icon" @click="delExampleImg(exampleImg)"></span>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-if="[4].includes(form.questionsType)" class="form_item" label="回答方式" required>
            <div class="answer_way">
              <div class="answer_way_check">
                <el-checkbox class="form_item_checkbox" v-model="form.answerType['1']">图片</el-checkbox>
                <el-checkbox class="form_item_checkbox" v-model="form.answerType['2']">文本</el-checkbox>
              </div>
              <div v-show="form.answerType['1']" class="answer_way_img">
                <div class="answer_way_img_upload">
                  <span class="el-icon-plus answer_way_img_upload_icon"></span>
                </div>
                <div class="answer_way_img_tips">限jpg/png文件，最多上传5张</div>
              </div>
              <div v-show="form.answerType['2']" class="answer_way_text">
                <el-input class="answer_way_text_input" placeholder="请输入" disabled></el-input>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <div class="footer_left"></div>
        <div class="footer_right">
          <el-button @click="close">取 消</el-button>
          <el-button type="primary" @click="submit">保 存</el-button>
        </div>
      </div>
    </el-dialog>
    <Upload ref="uploadImage" @on-success="uploadImgSuccess" @isLoading="uploadLoadingChange" accept=".png,.jpg,.jpeg"></Upload>
  </div>
</template>

<script>
  import Upload from '@/components/Upload/Upload.vue'

  import { uploadTemporaryFile } from "@/api/post"

  export default {
    name: 'questionEdit',
    components: {
      Upload
    },
    data () {
      return {
        input: '',
        visible: false,
        form: {
          vId: null,
          id: null,
          questionsType: 0,
          required: 1,
          questionsTitle: '',
          questionDescribe: '',
          answers: [],
          sampleImages: [],
          answerType: {
            '1': false,
            '2': false
          }
        },
        rules: {
          questionsType: [{ required: true, message: '请选择题目类型', trigger: 'change' }],
          required: [{ required: true, message: '请选择是否必填', trigger: 'change' }],
          questionsTitle: [{ required: true, message: '请输入问题名称', trigger: 'blur' }]
        },
        uploading: false
      }
    },
    methods: {
      generateUUID () {
        return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0
          const v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      },
      open (sourceInfo) {
        const info = JSON.parse(JSON.stringify(sourceInfo))
        this.visible = true
        this.form.vId = info.vId
        this.form.id = info.id
        this.form.questionsType = [null, undefined, ''].includes(info.questionsType) ? 0 : info.questionsType
        this.form.required = [null, undefined, ''].includes(info.required) ? 1 : info.required
        this.form.questionsTitle = info.questionsTitle
        this.form.questionDescribe = info.questionDescribe

        if ([null, undefined, ''].includes(info.vId)) {
          this.form.answers = [
            { vId: this.generateUUID(), answerContent: '' },
            { vId: this.generateUUID(), answerContent: '' }
          ]
        } else {
          this.form.answers = info.answers && info.answers.map(v => {
            v['vId'] = this.generateUUID()
            return v
          }) || []
        }

        this.form.sampleImages = info.sampleImages || []

        this.form.answerType['1'] = info.answerType.includes('1')
        this.form.answerType['2'] = info.answerType.includes('2')
      },
      close () {
        this.form.id = null
        this.form.questionsType = 0
        this.form.required = 1
        this.form.questionsTitle = ''
        this.form.questionDescribe = ''
        this.form.answers = []
        this.form.sampleImages = []
        this.form.answerType['1'] = false
        this.form.answerType['2'] = false
        this.$refs['form'].resetFields()
        this.visible = false
      },
      questionsTypeChange (type) {
        switch (type) {
          case 0:
            this.form.sampleImages = []
            this.form.answerType['1'] = false
            this.form.answerType['2'] = false
            if (this.form.answers.length === 0) {
              this.form.answers = [
                { vId: this.generateUUID(), answerContent: '' },
                { vId: this.generateUUID(), answerContent: '' }
              ]
            }
            break
          case 1:
            this.form.sampleImages = []
            this.form.answerType['1'] = false
            this.form.answerType['2'] = false
            if (this.form.answers.length === 0) {
              this.form.answers = [
                { vId: this.generateUUID(), answerContent: '' },
                { vId: this.generateUUID(), answerContent: '' }
              ]
            }
            break
          case 4:
            this.form.answers = []
            break
        }
      },
      addAnswer () {
        this.form.answers.push({
          vId: this.generateUUID(),
          answerContent: ''
        })
      },
      delAnswer (vId) {
        const index = this.form.answers.findIndex(item => item.vId === vId)
        if (index > -1) {
          this.form.answers.splice(index, 1)
        }
      },
      uploadExampleImg () {
        if (this.form.sampleImages.length >= 5) {
          return this.$message.error('最多上传5张图片')
        }
        this.$refs['uploadImage'].$el.querySelector('input').click()
      },
      uploadImgSuccess (data) {
        this.uploading = true
        let arr = []
        arr[0] = { uploadChannel: "postImg", fileId: data, groupName: "group1", isNeedThumbnail: "2" }
        uploadTemporaryFile(arr).then(uploadRes => {
          this.uploading = false
          if (uploadRes.errorCode == '0000') {
            this.form.sampleImages.push(uploadRes.data[0].fullPathUrl)
          } else {
            this.$message.error('上传失败')
          }
        }).catch(() => {
          this.uploading = false;
          this.$message.error('上传失败')
        })
      },
      uploadLoadingChange (loading) {
        this.uploading = loading
      },
      delExampleImg (url) {
        const index = this.form.sampleImages.findIndex(v => { return v == url })
        if (index > -1) {
          this.form.sampleImages.splice(index, 1)
        }
      },
      submit () {
        this.$refs['form'].validate(valid => {
          if (valid) {
            const hasEmpty = this.form.answers.some(v => { return [null, undefined, ''].includes(v.answerContent) })
            if ([0, 1].includes(this.form.questionsType)) {
              if (hasEmpty) {
                this.$message.error('题目选项不能为空')
                return
              }
              if (this.form.answers.length < 2) {
                return this.$message.error('请填写至少两个题目选项')
              }
            }
            const answerType = Object.keys(this.form.answerType).filter(v => this.form.answerType[v])
            if ([2].includes(this.form.questionsType)) {
              if (answerType.length === 0) {
                return this.$message.error('请选择回答方式')
              }
            }
            const info = {
              vId: this.form.vId,
              id: this.form.id,
              questionsType: this.form.questionsType,
              required: this.form.required,
              questionsTitle: this.form.questionsTitle,
              questionDescribe: this.form.questionDescribe,
              answers: this.form.answers,
              sampleImages: this.form.sampleImages,
              answerType: answerType
            }
            this.$emit('submit', JSON.parse(JSON.stringify(info)))
            this.close()
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .questionEdit /deep/ input[aria-hidden=true] {
    display: none !important;
  }
  .questionEdit_dialog /deep/ .el-dialog {
    border-radius: 4px;
  }
  .questionEdit_dialog /deep/ .el-dialog__header {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 24px;
    height: 48px;
    border-bottom: 1px solid #EBEAEE !important;
  }

  .questionEdit_dialog /deep/ .el-dialog__title {
    line-height: 24px;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }

  .questionEdit_dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
  }

  .questionEdit_dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .questionEdit_dialog /deep/ .el-dialog__footer {
    padding: 0;
  }

  .content {
    box-sizing: border-box;
    padding: 20px 24px;
    width: 100%;
    max-height: 600px;
    background-color: #FFFFFF;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .form {
    width: 100%;
    overflow: hidden;
  }

  .form_item {
    margin-bottom: 20px;
  }

  .form_item /deep/ .el-form-item__label {
    line-height: 32px;
    font-size: 14px;
    color: #667182;
  }

  .form_item /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .form_item_radio_group {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 32px;
  }

  .form_item_radio {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 32px 0 0;
    width: 70px;
  }

  .answer_list {
    width: 100%;
  }

  .answer_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 32px;
  }

  .answer_item+.answer_item {
    margin: 4px 0 0 0;
  }

  .answer_single_radio {
    flex-grow: 1;
    box-sizing: border-box;
    margin: 0 0 0 0;
    padding: 0 12px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
  }

  .answer_single_radio.error {
    background-color: #FDE2E2 !important;
  }

  .answer_item:hover .answer_single_radio {
    background-color: #F7F8F9;
  }

  .answer_single_radio:focus-within {
    background-color: #F7F8F9;
  }

  .answer_single_radio /deep/ .el-radio__label {
    box-sizing: border-box;
    display: inline-block;
    padding: 0 0 0 8px;
    width: calc(100% - 14px);
  }

  .answer_multiple_checkbox {
    flex-grow: 1;
    box-sizing: border-box;
    margin: 0 0 0 0;
    padding: 0 12px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
  }

  .answer_multiple_checkbox.error {
    background-color: #FDE2E2 !important;
  }

  .answer_item:hover .answer_multiple_checkbox {
    background-color: #F7F8F9;
  }

  .answer_multiple_checkbox:focus-within {
    background-color: #F7F8F9;
  }

  .answer_multiple_checkbox /deep/ .el-checkbox__label {
    box-sizing: border-box;
    display: inline-block;
    padding: 0 0 0 8px;
    width: calc(100% - 14px);
  }

  .answer_item_input {
    padding: 0;
    width: 100%;
  } 

  .answer_item_input /deep/ .el-input__inner {
    padding: 0;
    height: 20px;
    border: none;
    background-color: transparent;
  }

  .answer_item_del {
    flex-shrink: 0;
    margin: 0 12px;
    padding: 0;
    font-size: 18px;
    color: #667182;
    visibility: hidden;
  }

  .answer_item:hover .answer_item_del {
    visibility: visible;
  }

  .answer_item:focus-within .answer_item_del {
    visibility: visible;
  }

  .answer_add {
    padding: 0;
    line-height: 20px;
  }

  .answer_item + .answer_add {
    margin: 16px 0 0 0;
  }

  .example {
    width: 100%;
  }

  .example_operate {
    width: 100%;
  }

  .example_operate_btn {
    padding: 0 12px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
  }

  .example_operate_tips {
    line-height: 18px;
    font-size: 12px;
    color: #606266;
  }

  .example_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 12px -12px -12px 0;
    width: 100%;
    overflow: hidden;
  }

  .example_item {
    position: relative;
    z-index: 1;
    margin: 0 12px 12px 0;
    width: 80px;
    height: 80px;
    border: 1px solid #D3D3D5;
    background-color: #FFFFFF;
    border-radius: 2px;
  }

  .example_item_img {
    width: 100%;
    height: 100%;
  }

  .example_item_del {
    position: absolute;
    z-index: 2;
    top: 0px;
    left: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    visibility: hidden;
  }

  .example_item:hover .example_item_del {
    visibility: visible;
  }

  .example_item_del_icon {
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
  }

  .answer_way {
    width: 100%;
  }

  .answer_way_check {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 32px;
  }

  .form_item_checkbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 32px 0 0;
    width: 70px;
  }

  .answer_way_img {
    margin: 20px 0 0 0;
  }

  .answer_way_img_upload {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 148px;
    height: 148px;
    background-color: #F9F9FA;
    border: 1px dashed #DCDFE6;
    border-radius: 6px;
  }

  .answer_way_img_upload_icon {
    font-size: 28px;
    color: #303133;
  }

  .answer_way_img_tips {
    margin: 6px 0 0 0;
    line-height: 18px;
    font-size: 12px;
    color: #606266;
  }

  .answer_way_text {
    margin: 20px 0 0 0;
    width: 100%;
  }

  .answer_way_text_input {
    width: 100%;
  }

  .answer_way_text_input.is-disabled /deep/ .el-input__inner {
    background-color: #F9F9FA;
    border-color: #D3D3D5;
  }

  .footer {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    width: 100%;
    height: 56px;
    background-color: #FFFFFF;
    border-top: 1px solid #E0E0E0;
  }

  .footer_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .footer_btn_add {
    font-size: 14px;
    color: #1890FF;
  }

  .footer_right {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
</style>